import { PerPageItemsCount, SubDetailsListingItemCount, SubListingPageItemCount } from "../constants/uiConstants";

export interface RowCountResult {
  perPageItemsCount: number;
  subListingPageItemCount: number;
  subDetailsListingItemCount: number;
}

const MainListDefaultPageItemsCount = 100;
const SubListDefaultPageItemsCount = 50;

export const useRowCount = (): RowCountResult => {
  const screenSize = undefined; // React.useContext<ScreenSize | undefined>(ScreenSizeContext);

  return {
    perPageItemsCount: screenSize ? PerPageItemsCount[screenSize] : MainListDefaultPageItemsCount,
    subListingPageItemCount: screenSize ? SubListingPageItemCount[screenSize] : SubListDefaultPageItemsCount,
    subDetailsListingItemCount: screenSize ? SubDetailsListingItemCount[screenSize] : SubListDefaultPageItemsCount,
  };
};
